import React from "react";
import { connect } from "react-redux";
import { setCheckDataThunk } from "../../../redux/applicant-reducer";
import { setOpenCheckOrder } from "../../../redux/data-reducer";
import CheckOrder from "./CheckOrder";

class CheckOrderContainer extends React.Component {
 
  
  render() {
    const handleClose =()=>{
      this.props.setOpenCheckOrder(false)
    } 
    return (
      <div>
        <CheckOrder {...this.props} handleClose={handleClose}/>
      
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    open: state.data.openCheckOrder,
    alertMessage:state.applicantPage.checkDataMessage,
    hasApplicant: state.applicantPage.hasApplicant
});

export default connect(mapStateToProps, {setOpenCheckOrder, submit:setCheckDataThunk})(CheckOrderContainer);
